import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/twitter-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-0d06f304"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "checkout-post-mint-message"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "checkout-tx-details" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "checkout-success-actions" }
const _hoisted_6 = { class: "checkout-tweet" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Tweet this drop", -1))
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "twitter logo"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tweet", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "checkout-subscribe" }
const _hoisted_13 = { class: "checkout-subscribe-title" }
const _hoisted_14 = ["data-creator-address", "data-tweet-subtext"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Subscribe", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "checkout-platform-links" }
const _hoisted_19 = { class: "m-claim__post-checkout__secondary-actions" }
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "View my tokens", -1))

import { ArrowTopRightOnSquareIcon } from '@heroicons/vue/24/outline';
import { computed } from 'vue';
import TransactionDetails from '@/components/checkout/TransactionDetails.vue';
import PlatformLinks from '@/components/PlatformLinks.vue';
import { pluralize } from '@/lib/claimUtil';
import { useClaimStore } from '@/store/claimStore';
import CreateYourOwn from '../CreateYourOwn.vue';

interface CheckoutSuccessPageProps {
  paymentMethod: 'eth' | 'card';
  txHash?: string;
  email?: string;
  recipientAddress?: string | null;
  hideCreateYourOwn?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutSuccessPage',
  props: {
    paymentMethod: {},
    txHash: {},
    email: {},
    recipientAddress: {},
    hideCreateYourOwn: { type: Boolean }
  },
  setup(__props: any) {



const store = useClaimStore();

const tweetLabel = computed(() => {
  if (store.cost.eq(0)) {
    return 'claimed';
  } else {
    return 'purchased';
  }
});

const tweetText = computed(() => {
  if (store.creator.twitterHandle) {
    return `I just ${tweetLabel.value} ${store.name} from @${store.creator.twitterHandle} via @manifoldxyz%0A%0Ahttps://app.manifold.xyz/c/${store.slug}?utm_source=minted_tweet`;
  }

  return `I just ${tweetLabel.value} ${store.name} from ${store.creatorEnsOrFormattedWalletAddress} via @manifoldxyz%0A%0Ahttps://app.manifold.xyz/c/${store.slug}?utm_source=minted_tweet`;
});

function handleViewTokensClick() {
  store.analytics.capture({
    event: 'claim_widget:experiment:collector_profile_click',
    properties: {
      'link-location': 'post_checkout_links',
      experiment: 'profile_interest',
    },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(store).clientThemedText?.postMint)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", {
            class: "checkout-post-mint-title",
            innerHTML: _unref(store).clientThemedText?.postMint
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.txHash)
        ? (_openBlock(), _createBlock(TransactionDetails, {
            key: 0,
            "network-id": _unref(store).networkId || 1,
            "transaction-hash": _ctx.txHash || ''
          }, null, 8, ["network-id", "transaction-hash"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.paymentMethod === 'card' && !_ctx.recipientAddress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("p", null, " You'll now receive an email at " + _toDisplayString(_ctx.email) + " with your " + _toDisplayString(_unref(pluralize)(_unref(store).tokensToPurchase, 'item')), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("a", {
          class: "checkout-tweet-button",
          href: `https://twitter.com/intent/tweet?text=${tweetText.value}`,
          target: "_blank"
        }, _hoisted_11, 8, _hoisted_8)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("h3", _hoisted_13, " Never miss a drop by " + _toDisplayString(_unref(store).creatorEnsOrFormattedWalletAddress), 1),
        _createElementVNode("div", {
          "data-widget": "m-widget-subscribe",
          "data-creator-address": _unref(store).creator?.address,
          "data-tweet-subtext": `%0A%0Ahttps://app.manifold.xyz/c/${_unref(store).slug}?utm_source=subscribed_tweet`
        }, _hoisted_17, 8, _hoisted_14)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(PlatformLinks, {
          postCheckout: "",
          label: "View on",
          is1155: _unref(store).is1155,
          "has-mints": _unref(store).total > 0,
          "creator-contract-address": _unref(store).creatorContractAddress,
          "token-id": _unref(store).tokenId === null ? null : _unref(store).tokenId
        }, null, 8, ["is1155", "has-mints", "creator-contract-address", "token-id"])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      (!_ctx.hideCreateYourOwn)
        ? (_openBlock(), _createBlock(CreateYourOwn, {
            key: 0,
            class: "m-claim__post-checkout__action",
            "instance-slug": _unref(store).slug ?? null,
            "app-id": _unref(store).appId ?? null
          }, null, 8, ["instance-slug", "app-id"]))
        : _createCommentVNode("", true),
      (_unref(store).walletAddress)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "m-claim__post-checkout__action",
            href: `https://opensea.io/${_unref(store).walletAddress}`,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: handleViewTokensClick,
            "data-ph-capture-attribute-link-location": "post_checkout_links",
            "data-ph-capture-attribute-experiment": "profile_interest"
          }, [
            _hoisted_21,
            _createVNode(_unref(ArrowTopRightOnSquareIcon))
          ], 8, _hoisted_20))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})